type Props = {
  trackingId: string;
};

export function HorizonGoogleTagManagerNoScript({ trackingId }: Props) {
  return (
    <noscript>
      {/* oxlint-disable-next-line jsx_a11y/iframe-has-title, react/iframe-missing-sandbox */}
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${trackingId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      ></iframe>
    </noscript>
  );
}
